<template>
  <router-link class="block w-auto text-black transition-all font-medium text-body-m md:text-body-s py-2
                      border-b border-transparent hover:text-gray-500 hover:border-gray-500 focus:border-gray-500
                      group-data-[scroll-at-top=false]/header:hover:text-white
                      group-data-[scroll-at-top=false]/header:hover:!border-white
               "
               active-class="!border-black focus:border-gray-500"
  >
    <slot />
  </router-link>
</template>
